import _ from 'classnames';
import React from 'react';
import styles from "./TrackLabel.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function TrackLabel({
  content,
  vAlign,
  hAlign
}) {
  let className;
  if (vAlign === 'start' && hAlign === 'start') {
    className = styles.A;
  } else if (vAlign === 'start' && hAlign === 'end') {
    className = styles.B;
  } else if (vAlign === 'end' && hAlign === 'start') {
    className = styles.D;
  } else if (vAlign === 'end' && hAlign === 'end') {
    className = styles.E;
  }
  return /*#__PURE__*/_jsx("div", {
    className: _(styles.TrackLabel, className),
    children: content
  });
}